module.exports = __webpack_public_path__ + "static/media/logo.5db9ffac.png";